import { useState } from 'react';
import UploadFileDialog from './UploadFileDialog';
import { ListFiles } from './ListFiles';
import { File, GetAssemblyDetailsQuery } from '@/__generated__/graphql';
import { MediaActionButtons } from '@/components/shared/MediaActionButtons';
import { Attachment } from '@/components/shared/AttachmentDisplay/type';
import { Stack } from '@mui/material';

type Props = {
  referenceId: string;
  collectionName: string;
  files: File[];
  loading: boolean;
  onCaptureClick?: () => Promise<void>;
  location?: string;
  assembly?: GetAssemblyDetailsQuery['assembly']
};

export const FileUploadAndViewer = ({
  files,
  referenceId,
  collectionName,
  loading,
  onCaptureClick,
  location = '',
  assembly
}: Props) => {
  const [openFileDialog, setOpenFileDialog] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [attachments, setAttachments] = useState<Attachment[]>([]);

  const dialogTitle = 'Attachments';
  const buttonText = 'Add';
  const handleDialogToggle = () => setOpenFileDialog(!openFileDialog);
  return (
    <>
      <Stack gap="1.4rem" overflow="hidden">
        <MediaActionButtons
          loading={loading || isUpdating}
          onUploadClick={handleDialogToggle}
          onCaptureClick={onCaptureClick}
          location={location}
        />
        <ListFiles
          attachments={attachments}
          setAttachments={setAttachments}
          referenceId={referenceId}
          collectionName={collectionName}
          files={files}
          setIsUpdating={setIsUpdating}
          allFiles={files}
          location={location}
          setOpenDialog={setOpenFileDialog}
          assembly={assembly}
        />
      </Stack>
      <UploadFileDialog
        openDialog={openFileDialog}
        setOpenDialog={setOpenFileDialog}
        referenceId={referenceId}
        collectionName={collectionName}
        attachments={attachments}
        dialogTitle={dialogTitle}
        buttonText={buttonText}
        setAttachments={setAttachments}
        setIsUpdating={setIsUpdating}
        location={location}
        assembly={assembly}
      />
    </>
  );
};
